module.exports = __webpack_public_path__ + "features-select.287490c818d66147494ae5db3abf7abc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features-select.svg
// module id = 1137
// module chunks = 0